export class Account {
  id: string;
  email: string;
  pw: string;
  salt: string;
  name: string;
  jobTitle: string;
  permission: string = "USER";
  state: string = "ACTIVE";
  phone: string;
  createdBy: string;
  created: any;
  modifiedBy: string;
  modified: any;
  deleted: any;
  roles: any[] = [];

  constructor(obj?: any) {
    const account = obj || {};
    Object.assign(this, account);
    this.created = account.created ? new Date(account.created) : null;
    this.modified = account.modified ? new Date(account.modified) : null;
    this.deleted = account.deleted ? new Date(account.deleted) : null;
  }

  public get isRoot(): boolean {
    return this.id == '00000000-0000-0000-0000-100000000000';
  }

  public get isAdmin(): boolean {
    return this.permission == 'ADMIN';
  }
}
